import { render } from "./PublicQualityAssurancePreview.vue?vue&type=template&id=0801a9a1"
import script from "./PublicQualityAssurancePreview.vue?vue&type=script&lang=js"
export * from "./PublicQualityAssurancePreview.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/gradbeni-dnevnik/gradbeni-dnevnik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__